import { z } from 'zod';
import { rpc } from './rpc';
import { availabilitySchema, publicBookingSchema, publicTenantSchema, reminderSchema, type PublicBooking } from './schemas';

export interface CustomerInput {
  name: string;
  phone: string;
  car: string;
  plate?: string;
  comment?: string;
}

export const publicApi = {
  tenant: (slug: string) => rpc('get_public_tenant', { p_slug: slug }, publicTenantSchema),

  availability: (slug: string, serviceId: string, from: string | null, days: number) =>
    rpc('get_availability', { p_slug: slug, p_service_id: serviceId, p_from: from, p_days: days }, availabilitySchema),

  /** Server derives tenant, price and duration; the client only names service and time. */
  createBooking: (input: {
    slug: string;
    serviceId: string;
    startsAt: string;
    customer: CustomerInput;
    idempotencyKey: string;
    accessToken: string;
  }) =>
    rpc(
      'create_booking',
      {
        p_slug: input.slug,
        p_service_id: input.serviceId,
        p_starts_at: input.startsAt,
        p_customer: input.customer,
        p_idempotency_key: input.idempotencyKey,
        p_access_token: input.accessToken,
      },
      publicBookingSchema,
    ),

  bookings: (slug: string, tokens: string[]): Promise<PublicBooking[]> =>
    tokens.length === 0
      ? Promise.resolve([])
      : rpc('get_bookings', { p_slug: slug, p_tokens: tokens }, z.array(publicBookingSchema)),

  cancel: (slug: string, token: string, reason?: string) =>
    rpc('cancel_booking', { p_slug: slug, p_token: token, p_reason: reason ?? null }, publicBookingSchema),

  registerPush: (slug: string, token: string, subscription: PushSubscriptionJSON & { userAgent?: string }) =>
    rpc(
      'register_customer_push',
      { p_slug: slug, p_token: token, p_subscription: subscription },
      z.object({ reminder: reminderSchema }),
    ),

  unregisterPush: (slug: string, token: string, endpoint: string) =>
    rpc(
      'unregister_customer_push',
      { p_slug: slug, p_token: token, p_endpoint: endpoint },
      z.object({ reminder: reminderSchema }),
    ),
};
